import { Injectable } from '@angular/core';
import { saveAs } from 'file-saver';
import { IAutoTablePDFConfig } from '../components/shared/anteprima-pdf/IAutoTablePDFConfig';
import { Utenteservice } from './utente.service';

//import {Document, Packer, Paragraph, Table, TableCell, TableRow, HeadingLevel,AlignmentType,Footer,PageNumber,TextRun,Header,IHeaderOptions,WidthType,BorderStyle,PageOrientation,PageSizeAttributes } from 'docx';



const docx = require('docx');

const { Document, Packer, Paragraph, Table, TableCell, TableRow, HeadingLevel,AlignmentType,Footer,PageNumber,TextRun,Header,WidthType,BorderStyle,PageOrientation,PageSizeAttributes } = docx;


@Injectable({
  providedIn: 'root'
})


export class DocxExporterService {

    $title:string="";
    $date:string="";
    $time:string="";
    $totalPages:string="";
    $userName:string="";
    $nomeCompleto:string="";
    $descr_licenza:string="";

  constructor(private utenteService:Utenteservice) { 

    let datiUtente = utenteService.InfoDatiUtenteConnesso;
    
    this.$userName = datiUtente.userName;

    this.$nomeCompleto = datiUtente.nomeCompleto;

    this.$descr_licenza = datiUtente.descr_licenza;

    

  }

  
  

  async realizzaDocumento(json?:IAutoTablePDFConfig){
console.log(json)
    if(!json)
        return;


    let data:Date=new Date();

    //A differenza di excel e pdf, in word le celle non valorizzate verranno wrappate, quindi faccio questa procedura affinché non vengano wrappate 
    for(let colonna of json.Headers){

        for(let riga of json.Rows){

            

                if(!Object.keys(riga).includes(colonna.field))
                    riga[`${colonna.field}`] = "";

            
                if(colonna.field=='guidAccettazione'){ //Caso specifico guidAccettazione
                    if(riga[`${colonna.field}`].length>0)
                        riga[`${colonna.field}`] = "In Attesa";
                    else
                        riga[`${colonna.field}`] = "Confermata";      
                }

        }

    }//fine procedura


    this.$date=`${data.getDate() < 10 ? '0'+data.getDate() : data.getDate() }/${data.getMonth()+1 < 10 ? '0'+(data.getMonth()+1) : (data.getMonth()+1)}/${data.getUTCFullYear()}`;
    this.$time=`${data.getHours() < 10 ? '0'+data.getHours() : data.getHours()}:${data.getMinutes() < 10 ? '0'+data.getMinutes() : data.getMinutes()}:${data.getSeconds() < 10 ? '0'+data.getSeconds() : data.getSeconds()}`;
    this.$title=json.Page.title;
    /*
    const moment = require('moment');

    const formatiDateTime=[
        moment.ISO_8601
    ]
    */
    
    
     //Costruiamo l'Intestazione delle Righe
     let righeDocx :any[]= [];
     
     let tableHeader = new TableRow({children:[],tableHeader:true});

     for(let colonna of json.Headers){

        tableHeader.addChildElement(
            new TableCell({
                children:[
                    new Paragraph({
                        text:this.formatta(colonna.caption),
                        heading: HeadingLevel.HEADING_4,
                        
                        alignment: colonna.align.toLowerCase()=='l' || colonna.align.toLowerCase()=='left' ? AlignmentType.LEFT : colonna.align.toLowerCase()=='c' || colonna.align.toLowerCase()=='center' ? AlignmentType.CENTER : colonna.align.toLowerCase()=='r' || colonna.align.toLowerCase()=='right' ? AlignmentType.RIGHT : AlignmentType.LEFT
                    })
                ]
            })
        )
        

     }

     righeDocx.push(tableHeader);


// --- COSTRUZIONE RIGHE ---
for (var i = 0; i < json.Rows.length; i++) {
  var riga = json.Rows[i];
  var celle = [];

  for (var j = 0; j < json.Headers.length; j++) {
    var colonna = json.Headers[j];
    var key = colonna.field;
    var value = riga[key];

    // Normalizza valore
    if (value === null || value === undefined || value === "null" || value === "undefined" || value === "") {
      value = "";
    } else if (typeof value === "boolean") {
      value = value ? "Si" : "No";
    }

    // Gestione speciale tipoAttivita
    if (key === "tipoAttivita") {
      var attivitaSvolte = "";
      if (riga["isProduttore"] === true) attivitaSvolte += "P ";
      if (riga["isTrasportatore"] === true) attivitaSvolte += "T ";
      if (riga["isDestinatarioRifiuto"] === true) attivitaSvolte += "D ";
      if (riga["isIntermediario"] === true) attivitaSvolte += "I ";
      attivitaSvolte = attivitaSvolte.trim().replace(/[ ]/g, "-");
      value = attivitaSvolte;
    }

    // Allineamento
    var align = AlignmentType.LEFT;
    var a = colonna.align.toLowerCase();
    if (a === "c" || a === "center") align = AlignmentType.CENTER;
    if (a === "r" || a === "right") align = AlignmentType.RIGHT;

    // Crea cella
    var cella = new TableCell({
      children: [new Paragraph({ text: String(value), alignment: align })]
    });

    celle.push(cella);
  }

  // Crea riga solo se ci sono celle
  if (celle.length > 0) {
    righeDocx.push(new TableRow({ children: celle }));
  }
}

// --- COSTRUZIONE TABELLA ---
if (righeDocx.length === 0) {
  console.error("❌ Nessuna riga costruita: controlla json.Headers e json.Rows");
  return;
}

var tableBody = new Table({
  rows: righeDocx,
  width: { size: 5000, type: WidthType.PERCENTAGE }
});


    

    //Costruzione HEADER PAGE
    
    let tableHeaderTitlePageRow = new TableRow({children:[]});   
    let tableHeaderPageRow = new TableRow({children:[]});   


    for(let head of json.HeaderPage){

        if(head.text.toLowerCase().includes('$title')){
           /*
            tableHeaderTitlePageRow.addChildElement(
                new TableCell({
                    children:[
                        new Paragraph({
                            text:''
                        })
                    ]
                })
            );
             */  
            tableHeaderTitlePageRow.addChildElement(
                new TableCell({
                    borders: {
                        top: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
                        bottom: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
                        left: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
                        right: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
                      },
                    children: [new Paragraph({
                heading:HeadingLevel.HEADING_1,
                alignment:(head.align=='l' || head.align=='left') ? AlignmentType.LEFT : (head.align=='c' || head.align=='center') ?  AlignmentType.CENTER : (head.align=='r' || head.align=='right') ?  AlignmentType.RIGHT : AlignmentType.LEFT ,
                children:[
                    new TextRun({
                        bold:true,
                        text:this.formatta(head.text)
                    })
                ]
                })
            ]}));
            /*
            tableHeaderPageRow.addChildElement(
                new TableCell({
                    children:[]
                })
            );
            */
            /*
            paragrafiHeader.unshift(
                new Paragraph({
                    heading:HeadingLevel.HEADING_1,
                    alignment:(head.align=='l' || head.align=='left') ? AlignmentType.LEFT : (head.align=='c' || head.align=='center') ?  AlignmentType.CENTER : (head.align=='r' || head.align=='right') ?  AlignmentType.RIGHT : AlignmentType.LEFT ,
                    children:[
                        new TextRun({
                            bold:true,
                            text:this.formatta(head.text)
                        })
                    ]
                })
              );
            */
            
        }else{

           
            
                
                    
                    let tableCell = new TableCell({
                        width:{
                            size:'80%',
                            type: WidthType.PERCENTAGE
                        },
                        borders: {
                            top: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
                            bottom: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
                            left: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
                            right: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
                          },
                            children: [new Paragraph({
                                text:this.formatta(head.text) == 'true' ? 'Si'  : this.formatta(head.text) == 'false' ? 'No' : this.formatta(head.text) == 'null' || this.formatta(head.text) == 'undefined' ? '' /* :moment(riga[key],formatiDateTime,true).isValid() ? ''+riga[key].split('T')[0] */: this.formatta(head.text),
                                alignment: head.align.toLowerCase()=='l' || head.align.toLowerCase()=='left' ? AlignmentType.LEFT : head.align.toLowerCase()=='c' || head.align.toLowerCase()=='center' ? AlignmentType.CENTER : head.align.toLowerCase()=='r' || head.align.toLowerCase()=='right' ? AlignmentType.RIGHT : AlignmentType.LEFT
                            })
                        ]
                        })
                    
                
                    if(head.align.toLowerCase()=='l' || head.align.toLowerCase()=='left'){
                        tableHeaderPageRow.addCellToColumnIndex(tableCell,0);
                    }
                    if(head.align.toLowerCase()=='c' || head.align.toLowerCase()=='center'){
                        tableHeaderPageRow.addCellToColumnIndex(tableCell,1);
                    }
                    if(head.align.toLowerCase()=='r' || head.align.toLowerCase()=='right'){
                        tableHeaderPageRow.addCellToColumnIndex(tableCell,2);
                    }
               
            

        }
  
        
    }
    
    let tableHeaderPage = new Table(
        {
            rows:[tableHeaderTitlePageRow,tableHeaderPageRow],
            width:{
                size:'100%',
                type: WidthType.PERCENTAGE
            },
            borders: {
                top: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
                bottom: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
                left: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
                right: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
              }
        }
    );
  
    


    //setWidth(docx.WidthType.PERCENTAGE, '98%');


  let doc = new Document({
    
    sections: [{
        properties:{
            page:{size:{orientation:PageOrientation.LANDSCAPE}}
        },
        headers:{
            default:new Header({
                children:[tableHeaderPage]
            })
        },
        footers:{
            
                default:new Footer({
                    children:[new Paragraph({
                        children:[
                            new TextRun({
                                children:['Pag. ',PageNumber.CURRENT,' di ',PageNumber.TOTAL_PAGES]
                            })
                        ],
                        
                        alignment: AlignmentType.RIGHT
                    })]
                })
            
        },
        children: [tableBody],
    }]
});






  const b64string = await Packer.toBlob(doc);

  saveAs(new Blob([b64string], { type: 'application/octet-stream' }), `${json.Page.title}.docx`);
  }



  formatta(text:string):string{
                 
    let ris=text;

    //console.warn(this.$totalPages);

    ris=text.replace(/[$]pageNumber/g,PageNumber.CURRENT)
            .replace(/[$]totalPages/g,PageNumber.TOTAL_PAGES)
            .replace(/[$]date/g,this.$date)
            .replace(/[$]time/g,this.$time)
            .replace(/[$]userName/g,this.$userName)
            .replace(/[$]nomeCompleto/g,this.$nomeCompleto)
            .replace(/[$]descr_licenza/g,this.$descr_licenza)
            .replace(/[$]title/g,this.$title)
            .replace(/[$]/g,'');
            /*
            if(typeof pdf.putTotalPages === 'function'){
      
              ris=ris.replace(/[$]totalPages/g,numeroPagineTotaliExp);
             
              
            }
            */
    //console.log(ris);
    

    return ris;
   }
}
